import axios from "axios";
import i18n from "@/i18n";

export default {
  baseURL: process.env.BASE_URL + "api/administration",

  getClientSettings(clientId) {
    return axios
      .get("client-settings", {
        baseURL: this.baseURL,
        params: {
          "client-id": clientId
        }
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  setClientSettings(clientSettings) {
    return axios
      .put("client-settings", clientSettings, {
        baseURL: this.baseURL
      })
      .then(function(response) {
        return response;
      });
  },

  getThemes() {
    return axios
      .get("themes", {
        baseURL: this.baseURL
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  getCheckReportFileNameSamples(clientId, template) {
    return axios
      .get("get-check-report-filename-samples", {
        baseURL: this.baseURL,
        params: {
          "client-id": clientId,
          template: template
        }
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  getCheckReportPreview(
    clientId,
    clientSettings,
    theme,
    thresholds,
    options,
    cancelToken
  ) {
    return axios
      .post(
        "get-check-report-preview",
        {
          ClientId: clientId,
          ClientSettings: clientSettings,
          Theme: theme,
          Thresholds: thresholds,
          LocalizationId:
            options && options.localizationId
              ? options.localizationId
              : i18n.locale
        },
        {
          baseURL: this.baseURL,
          responseType: "blob",
          cancelToken: cancelToken ? cancelToken.token : null
        }
      )
      .then(function(response) {
        return response;
      });
  },

  getCheckUploadFileNameSamples(clientId, template) {
    return axios
      .get("get-check-upload-filename-samples", {
        baseURL: this.baseURL,
        params: {
          "client-id": clientId,
          template: template
        }
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  getSurveySettings(surveyId) {
    return axios
      .get("survey-settings", {
        baseURL: this.baseURL,
        params: {
          "survey-id": surveyId
        }
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  setSurveySettings(surveySettings) {
    return axios
      .put("survey-settings", surveySettings, {
        baseURL: this.baseURL
      })
      .then(function(response) {
        return response;
      });
  },

  getGeneralSettings() {
    return axios
      .get("general-settings", {
        baseURL: this.baseURL
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  setGeneralSettings(settings) {
    return axios
      .put("general-settings", settings, {
        baseURL: this.baseURL
      })
      .then(function(response) {
        return response;
      });
  },

  getApis() {
    return axios
      .get("cx-get-apis", {
        baseURL: this.baseURL
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  getScores(clientId, countryId) {
    return axios
      .get("cx-get-scores", {
        baseURL: this.baseURL,
        params: {
          "client-id": clientId,
          "country-id": countryId
        }
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  setScore(score) {
    return axios
      .post("cx-set-score", score, {
        baseURL: this.baseURL
      });
  },

  deleteScore(scoreId) {
    if (scoreId == -1) {
      return Promise.reject("OverallScore can't be deleted");
    }
    return axios
      .get("cx-delete-score", {
        baseURL: this.baseURL,
        params: {
          "score-id": scoreId
        }
      })
  },

  getCXSettings(settings) {
    if (!settings.LocalizationId) {
      settings.LocalizationId = i18n.locale;
    }
    return axios
      .post("cx-get", settings, {
        baseURL: this.baseURL
      });
  },

  setCXSettings(settings) {
    if (!settings.LocalizationId) {
      settings.LocalizationId = i18n.locale;
    }

    return axios
      .post("cx", settings, {
        baseURL: this.baseURL
      });
  },

  getCXClientSettings(clientId, cancelToken) {
    return axios
      .get("cxclient", {
        baseURL: this.baseURL,
        params: {
          "client-id": clientId
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  setCXClientSettings(settings, cancelToken) {
    return axios
      .post("cxclient", settings, {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  // First Aid Kit Groups
  updateFirstAidKitGroup(groupId, values, cancelToken) {
    return axios.put(`first-aid-group/${groupId}`,
      values,
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  hasFirstAidKitGroupResolutions(groupId, cancelToken) {
    return axios.get(`first-aid-group/${groupId}/has-resolutions`,
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  deleteFirstAidKitGroup(groupId, cancelToken) {
    return axios.delete(`first-aid-group/${groupId}`,
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  // Competitors
  getCompetitorSettings(locationId) {
    return axios.get("competitor", {
      baseURL: this.baseURL,
      params: {
        locationId: locationId
      }
    });
  },

  setCompetitorSettings(settings) {
    return axios.post("competitor", settings, {
      baseURL: this.baseURL
    });
  },

  getCompetitorLinks(locationId, googleId) {
    return axios
      .get("competitor-links", {
        baseURL: this.baseURL,
        params: {
          locationId: locationId,
          GoogleID: googleId
        }
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  getNearbyLocation(locationId) {
    return axios
      .get("competitor-nearby-location", {
        baseURL: this.baseURL,
        params: {
          locationId: locationId
        }
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  getClientLocations(filter, options, cancelToken) {
    return axios.get('client-locations',
      { 
        baseURL: this.baseURL,
        params: {
          'client-ids': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
          'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
          'localization-id': (options && options.localizationId) ? options.localizationId : i18n.locale,
          'page-size': options ? options.pageSize : null,
          'page': options ? options.page : null,
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  getNotifications(onlyForUser, onlyForLocation, cancelToken) {
    return axios.get('notifications',
      { 
        baseURL: this.baseURL,
        params: {
          'only-for-user': onlyForUser,
          'only-for-location': onlyForLocation
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  setNotifications(notifications) {
    return axios.put('notifications', notifications,
      { 
        baseURL: this.baseURL,
      });
  },

  getDefaultNotifications(clientId, includeUsers, cancelToken) {
    return axios.get('default-notifications',
      { 
        baseURL: this.baseURL,
        params: {
          'clientId': clientId,
          'includeUsers': includeUsers ? includeUsers : null
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  setDefaultNotifications(clientId, data) {
    return axios.put('default-notifications', data,
      { 
        baseURL: this.baseURL,
        params: {
          'clientId': clientId
        }
      });
  }
};
